interface TooltipConfig {
  themeTest: string;
  checkoutTest: string;
}

/**
 * Tooltip configuration for segment table headers.
 *
 * Note: Currently only cross-site/theme test tooltips are fully defined.
 * Checkout test tooltips (except ARPC) will be added in the future as needed.
 *
 */
export const SEGMENT_TABLE_TOOLTIPS: Record<string, TooltipConfig> = {
  'traffic%': {
    themeTest: 'Share of users traffic per experiment variations',
    checkoutTest: '',
  },
  users: {
    themeTest: 'The percentage of total experiment traffic assigned to each variation.',
    checkoutTest: '',
  },
  'stat. sig.': {
    themeTest:
      'Calculated as 1 − p-value (1 − p). A higher percentage is better, because it reflects a greater likelihood that the observed lift is real and not due to random chance',
    checkoutTest: '',
  },
  CVR: {
    themeTest:
      'Total orders from users who saw that variant divided by total users allocated to that experiment variant.',
    checkoutTest: '',
  },
  AOV: {
    themeTest: 'Total order revenue, excluding shipping, divided by the number of orders',
    checkoutTest: '',
  },
  ARPC: {
    themeTest: '', // Mutually exclusive: Only exists in checkout tests
    checkoutTest: 'ARPC (Annualized Revenue Per Checkout) \n is calculated as: (AOV+ASR) × (CVR) = ARPC',
  },
  ARPU: {
    themeTest: 'Total revenue divided by number of users',
    checkoutTest: '', // Mutually exclusive: Only exists in theme tests
  },
};

/**
 * Get the appropriate tooltip text for a given header based on test type
 * @param header - The column header name
 * @param isThemeTest - Whether this is a cross-site/theme test (vs checkout test)
 * @returns The tooltip text, or undefined if no tooltip should be shown (empty string means no tooltip)
 */
export const getTooltipText = (header: string, isThemeTest: boolean): string | undefined => {
  const config = SEGMENT_TABLE_TOOLTIPS[header];
  if (!config) return undefined;

  // Get the appropriate tooltip based on test type
  const tooltipText = isThemeTest ? config.themeTest : config.checkoutTest;

  // Return undefined if tooltip text is empty (so no tooltip is rendered)
  return tooltipText === '' ? undefined : tooltipText;
};
